module.exports = scale;